import React from "react";

import { displayPrice, parsePriceString } from "../../../../../services/utils";

import styles from "./summaryPrice.scss";

const SummaryPrice = ({ adSummary }) => {
  if (!adSummary.price || adSummary.price === 0) {
    return null;
  }

  return (
    <div className={styles.pricesWrapper}>
      <span className={styles.price} style={{
        marginBottom: adSummary.priceM2 ? 0 : 23
      }}>
        {displayPrice(
          adSummary.price,
          adSummary.priceTo,
          {
            rentPriceType: adSummary.rentPriceType,
            priceType: adSummary.priceType
          })}
      </span>

      {adSummary.previousPrice && (
        <span className={styles.prevPrice}>
          {parsePriceString(adSummary.previousPrice)}
        </span>
      )}
      {adSummary.priceM2 && (
        <div className={styles.priceM2}>
          {parsePriceString(Math.round(adSummary.priceM2))}/m<sup>2</sup>
        </div>
      )}


    </div>
  );
};

export default SummaryPrice;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/SummaryPrice/index.tsx